import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import allBlogPosts from '../../data/allBlogPosts';
import "./blog-post.css";

// Create a helper to sanitize a name into a slug
const sanitizeSlug = (name) =>
  name.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');

const BlogPost = () => {
    const [blogPost, setBlogPost] = useState(null);

    useEffect(() => {
        // Get the slug from the URL by removing the leading "/blog/"
        const slug = window.location.pathname.substring(6);
        // Find the post where the sanitized name matches the slug
        const foundPost = allBlogPosts.find(
          (post) => sanitizeSlug(post.name) === slug
        );
        setBlogPost(foundPost);
    }, []);

    useEffect(() => {
        if(blogPost){
          document.title = `${blogPost.name} | Casaantonio e piccolo gió`;
        }
    }, [blogPost]);

    // If no post was found, show a fallback
    if (!blogPost) {
      return <div>Blogbeitrag nicht gefunden.</div>;
    }

    return (
        <main className="blog-post">
            <Link to="/blog" className="blog-post__back-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                <span>Zurück zum Blog</span>
            </Link>
            <img src={blogPost.img} alt={blogPost.name} aria-hidden="true" />
            <section>
                <h2>{blogPost.name}</h2>
                <p>{blogPost.content}</p>
            </section>
        </main>
    )
}

export default BlogPost;